export const SEARCH = 'search'
export const SEARCH_BY_PROPERTY_REGISTRATION = 'searchByPropertyRegistration'
export const CONTACTS = 'contacts'
export const SET_LOADING = 'setLoading'
